import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Trabzon'a gitmek için en iyi zaman hangisi?",
    a: "Trabzon'u ziyaret etmek için en ideal dönemler Mayıs–Temmuz ve Eylül–Ekim aylarıdır. Bu dönemlerde yaylalar yemyeşil, hava ılıman ve doğa yürüyüşleri için mükemmeldir. Ağustos kalabalık olabilir. Kış aylarında (Aralık–Şubat) Uzungöl ve yaylalar kar altında masalsı bir görünüm kazanır; ancak bazı yollar kapanabilir.",
  },
  {
    q: "Trabzon'da mutlaka görülmesi gereken yerler hangileri?",
    a: "Sümela Manastırı, Uzungöl, Ayder Yaylası (Rize), Trabzon Kalesi, Ayasofya Müzesi (Trabzon), Boztepe Seyir Terası, Atatürk Köşkü, Hıdırnebi Yaylası ve Sera Gölü Trabzon çevresinin mutlaka görülmesi gereken yerleri arasındadır. Kaçkar Dağları trekking rotaları da deneyimli yürüyüşçüler için vazgeçilmezdir.",
  },
  {
    q: "Trabzon'da ne yenilmeli?",
    a: "Trabzon mutfağının öne çıkan lezzetleri: Trabzon pidesi (taş fırında, peynirli ve yumurtalı), kuymak (mısır unu ve peynirle yapılan geleneksel yemek), hamsi pilavı, karalahana çorbası, muhlama, Trabzon hurması, mısır ekmeği ve tereyağlı Karadeniz kahvaltısı. Şehrin tarihi pidecileri sabah 6'da açılır ve kuyruk oluşur.",
  },
  {
    q: "Trabzon'a nasıl gidilir?",
    a: "Trabzon Havalimanı, İstanbul, Ankara ve diğer büyük şehirlerden direkt uçuşlarla bağlantılıdır; İstanbul'dan uçuş süresi yaklaşık 1,5 saattir. İstanbul'dan otobüsle yaklaşık 16–18 saat sürer. Şehir içinde dolmuş ve taksi kullanılabilir. Sümela Manastırı ve Uzungöl için tur araçları veya özel araç kiralama önerilir.",
  },
  {
    q: "Sümela Manastırı nasıl ziyaret edilir?",
    a: "Sümela Manastırı, Trabzon'a 46 km uzaklıkta Maçka ilçesindedir. Şehir merkezinden araçla yaklaşık 1 saat sürer. Manastıra ulaşmak için yaklaşık 30 dakikalık bir yürüyüş gerekmektedir; patika orman içinden geçer. Ziyaret saatleri 08:00–19:00 (yaz) ve 08:00–17:00 (kış) arasındadır. Sabah erken saatlerde gitmek hem kalabalıktan kaçınmanızı hem de sis içindeki manastırı görmenizi sağlar.",
  },
  {
    q: "Uzungöl nasıl bir yer ve nasıl gidilir?",
    a: "Uzungöl, Trabzon'un Çaykara ilçesinde, 1.090 metre yükseklikte yer alan ve sabah sisiyle masalsı bir atmosfer sunan bir göldür. Trabzon şehir merkezinden yaklaşık 1,5 saat uzaklıktadır; dolmuş veya özel araçla ulaşılabilir. Göl çevresindeki yürüyüş parkurları, Haldizen Yaylası'na çıkan trekking rotaları ve geleneksel ahşap evler Uzungöl'ü unutulmaz kılar.",
  },
  {
    q: "Trabzon'dan Ayder Yaylası'na nasıl gidilir?",
    a: "Ayder Yaylası, Trabzon'a yaklaşık 2 saat uzaklıkta Rize'nin Çamlıhemşin ilçesindedir. Trabzon'dan Rize'ye, oradan Çamlıhemşin'e, ardından Ayder'e ulaşılır. Özel araç veya tur araçlarıyla gidilebilir. Ayder'de termal tesisler, şelaleler ve Kaçkar Dağları trekking rotaları sizi beklemektedir.",
  },
  {
    q: "Trabzon'da Kaçkar Dağları trekking rotaları nasıl?",
    a: "Kaçkar Dağları, Türkiye'nin en zorlu ve en ödüllendirici trekking rotalarına ev sahipliği yapar. Ayder veya Yusufeli'nden başlayan rotalar 3–7 gün sürebilir. Deneyimli rehberlerle yapılması önerilen bu yürüyüşlerde çadır veya yayla evlerinde konaklama yapılır. Haziran–Eylül ayları en uygun dönemdir. Temel dağcılık ekipmanı ve fiziksel kondisyon gerektirir.",
  },
  {
    q: "Trabzon'da çay bahçeleri ve çay kültürü nasıl?",
    a: "Trabzon ve Rize, Türkiye'nin çay üretiminin kalbi olup bölgede çay kültürü yaşamın ayrılmaz bir parçasıdır. Rize'deki çay bahçelerini ziyaret ederek çay hasadını yakından görebilirsiniz. Boztepe'deki çay bahçelerinde şehir manzarasına karşı çay içmek Trabzon'un en keyifli deneyimlerinden biridir. Taze çay yapraklarından yapılan çay, market çayından çok daha lezzetlidir.",
  },
  {
    q: "Trabzon'da konaklama seçenekleri nelerdir?",
    a: "Trabzon şehir merkezinde her bütçeye uygun otel seçenekleri mevcuttur. Uzungöl'de göl manzaralı butik oteller ve geleneksel ahşap evler bulunmaktadır. Ayder Yaylası'nda termal tesisli oteller ve yayla evleri konaklama imkânı sunar. Kaçkar trekking rotaları üzerindeki yayla evleri ise dağcılar için ideal bir seçenektir.",
  },
  {
    q: "Trabzon'da Boztepe nedir?",
    a: "Boztepe, Trabzon şehir merkezine 3 km uzaklıkta, denizden 450 metre yükseklikte yer alan ve şehrin en güzel panoramik manzarasını sunan bir seyir tepesidir. Karadeniz'e ve şehre bakan muhteşem manzarası, çay bahçeleri ve piknik alanlarıyla Trabzonluların en sevdiği dinlenme noktalarından biridir. Gün batımında Boztepe'de çay içmek, Trabzon deneyiminin vazgeçilmez bir parçasıdır.",
  },
  {
    q: "Trabzon'dan günübirlik gezi yapılabilecek yerler var mı?",
    a: "Trabzon'dan günübirlik yapılabilecek en popüler destinasyonlar: Sümela Manastırı (1 saat), Uzungöl (1,5 saat), Rize çay bahçeleri (1 saat), Ayder Yaylası (2 saat), Giresun Adası (tekne turu), Ordu Boztepe (1,5 saat) ve Artvin Borçka Karagöl (2,5 saat)'dür.",
  },
];

const TrabzonFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Trabzon Seyahat SSS — Sümela, Uzungöl ve Karadeniz Rehberi 2026";
    const desc = "Trabzon'a seyahat planlayanlar için en sık sorulan sorular: Sümela Manastırı, Uzungöl, Ayder Yaylası, Kaçkar trekking ve Karadeniz mutfağı hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/trabzon-sss");
    setMeta("description", desc);
    setMeta("keywords", "trabzon seyahat, sumela manastiri, uzungol, ayder yaylasi, kackar daglari, trabzon sss, karadeniz rehberi, trabzon gezilecek yerler, trabzon ne zaman gidilir, trabzon pide, trabzon kuymak, trabzon muhlama, trabzon hamsi, trabzon boztepe, trabzon ataturk koskü, trabzon ayasofya, trabzon kalesi, trabzon macka, trabzon caykara, rize cay bahceleri, rize firtina vadisi, rize pokut yaylasi, rize sal yaylasi, camlihemshin, haldizen yaylasi, hidirnebi yaylasi, sera golu, trabzon konaklama, trabzon ulasim, trabzon gunubirlik gezi, giresun adasi, ordu boztepe, artvin borcka karagol");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/trabzon-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Trabzon%20Sumela%20Monastery%20Black%20Sea%20Turkey%20Uzungol%20lake%20mountain%20forest%20Karadeniz%20panoramic&width=1200&height=630&seq=tra-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-trabzon-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-trabzon-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Trabzon SSS", "item": "https://geziturkiyem.com/trabzon-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      ["schema-trabzon-faq", "schema-trabzon-breadcrumb"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Trabzon%20Sumela%20Monastery%20cliff%20face%20dramatic%20mountain%20backdrop%20Black%20Sea%20region%20lush%20green%20forest%20Turkey%20wide%20panoramic&width=1400&height=500&seq=tra-sss-hero&orientation=landscape"
            alt="Trabzon"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Trabzon SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Trabzon Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            Trabzon'a seyahat planlayanların en çok merak ettiği sorular ve kapsamlı Karadeniz rehberi.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-water-flash-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Trabzon Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Karadeniz'in incisi Trabzon; Sümela Manastırı, Uzungöl'ün masalsı atmosferi, Kaçkar Dağları'nın zorlu trekking rotaları ve eşsiz Karadeniz mutfağıyla her yıl milyonlarca ziyaretçiyi ağırlamaktadır. Aşağıda Trabzon seyahati hakkında en sık sorulan soruları bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
          <Link to="/mardin-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-ancient-gate-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Mardin SSS</p>
            <p className="text-xs text-stone-400">Taş evler ve manastırlar rehberi</p>
          </Link>
          <Link to="/kapadokya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-landscape-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kapadokya SSS</p>
            <p className="text-xs text-stone-400">Peri bacaları ve balon turları</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TrabzonFaq;
